import { i18n } from '@fs/zion-locale'

export default {
  buttonText: () => i18n.t('BackToRecordsHomeButton.buttonText', 'Back to Records Home'),
}
